import classnames from 'classnames';
import React from 'react';
import { downloadFileFromUrl } from 'v2/utils/downloadFileFromUrl';
import { getSavedFileData } from 'v2/utils/fileUtils';
import restFactory from 'v2/utils/restFactory';
import { formatDataFileType } from 'v2/utils/textFormat';
import fileIcon from '../../icons/file2.svg';
import { DataFileEntity } from '../models';
import styles from './dataFileBoxV2.module.scss';

interface DataFileBoxV2Props {
  className?: string;
  data: DataFileEntity;
  allowDownload?: boolean;
}

const DataFileBoxV2 = ({
  data,
  className = '',
  allowDownload,
}: DataFileBoxV2Props) => {
  const fileData = getSavedFileData(data);
  return (
    <div
      className={classnames(
        'd-flex',
        styles.root,
        { [styles.enableHover]: allowDownload },
        className
      )}
      onClick={async () => {
        if (allowDownload) {
          const response = await restFactory.get<DataFileEntity>(
            `data-files/${data.id}`
          );
          downloadFileFromUrl(response.file);
        }
      }}
    >
      <img className="mr-2" src={fileIcon} alt="fileIcon" />
      <div className="w-75 data-file-box-v2--file-data-container">
        <h6
          className={classnames(
            'text-primary-dark m-0 text-truncate',
            styles.fileName
          )}
        >
          {fileData.name}
        </h6>
        <p className={classnames('m-0', styles.fileDescription)}>
          {formatDataFileType(data.file_type)} {fileData.size}
        </p>
      </div>
    </div>
  );
};

export default DataFileBoxV2;
